export default __webpack_public_path__ + "assets/a04b5471a9dbea9c29f68901fdbb3d2e.png";